import { fetchApi } from '../baseApi';

const API_BASE = 'api/s3';

export async function getUploadUrl(mimeType: string): Promise<{ preSignedUrl: string; fileKey: string, fileName: string }> {
    try {
        const response = await fetchApi(
            `${API_BASE}/upload-url?mimeType=${encodeURIComponent(mimeType)}`,
            'GET'
        );

        return await response; // { preSignedUrl: string, fileKey: string }
    } catch {
        throw new Error('Cannot get upload URL!');
    }
}

export async function getDownloadUrl(mimeType: string) {
    try {
        const response = await fetchApi(
            `${API_BASE}/download-url?mimeType=${encodeURIComponent(mimeType)}`,
            'GET'
        );

        return await response; // { preSignedUrl: string, fileKey: string }
    } catch {
        throw new Error('Cannot get download URL!');
    }
}

export function uploadToS3(presignedUrl: string, file: File | Blob): Promise<{ isSuccess: boolean; errorMessage: string }> {
    return new Promise((resolve) => {
        fetch(presignedUrl, {
            method: 'PUT',
            headers: {
                'Content-Type': file.type
            },
            body: file
        })
            .then(async (response) => {
                console.log('api uploadToS3: ', response);

                if (response.ok) {
                    resolve({
                        isSuccess: true,
                        errorMessage: ''
                    });
                } else {
                    const errorText = await response.text(); // detailed error if available
                    console.log(`Failed to upload video: ${response.status} ${response.statusText} - ${errorText}`);
                    resolve({
                        isSuccess: false,
                        errorMessage: 'Failed to upload video. Please contact your administrator for support.'
                    });
                }
            })
            .catch((error) => {
                console.log(`Unexpected error: ${error.message}`);
                resolve({
                    isSuccess: false,
                    errorMessage: `Unexpected error. Please contact your administrator for support.`
                });
            });
    });
}


// WEBPACK FOOTER //
// ./src/api/s3Storage/index.ts